import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=9d6633b0&"
import script from "./ErrorLayout.vue?vue&type=script&lang=js&"
export * from "./ErrorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d6633b0')) {
      api.createRecord('9d6633b0', component.options)
    } else {
      api.reload('9d6633b0', component.options)
    }
    module.hot.accept("./ErrorLayout.vue?vue&type=template&id=9d6633b0&", function () {
      api.rerender('9d6633b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth/src/layouts/ErrorLayout.vue"
export default component.exports